import React from 'react';
import styles from './styles.module.css';

export const Card: React.FC<{
  className?: string;
  children: React.ReactNode;
  'data-testid'?: string;
  id?: string;
}> = ({ children, className, 'data-testid': dataTestId, id }) => (
  <div
    id={id}
    data-testid={dataTestId}
    className={`${className ?? ''} ${styles.card}`}
  >
    {children}
  </div>
);
